import { pdfActive } from '@/components/icons/knowledge-base';
import { EKnowledgeBaseItemTypes } from '@/components/knowledgeBase/models';
import { Box, StyledComponentProps } from '@mui/material';
import styled from 'styled-components';

export interface WithType extends StyledComponentProps {
  type: EKnowledgeBaseItemTypes;
}

interface WithPreview extends WithType {
  hasPreview: boolean;
}

export const KnowledgeBaseSmallPreviewBlock = styled.div<WithPreview>`
  display: flex;
  margin: 22px 0;
  color: ${(props) => props.theme.knowledgeBase.color};

  &:hover {
    cursor: pointer;
  }

  .preview-image {
    margin-right: 22px;
    border-radius: 4px;
    height: 84px;

    &.completed {
      opacity: 0.5;
    }

    img {
      &:hover {
        content: ${(props) => {
          if (
            props.type === EKnowledgeBaseItemTypes.GUIDE &&
            !props.hasPreview
          ) {
            return `url(${pdfActive});`;
          }
          return '';
        }};
        filter: ${(props) => {
          if (
            props.type !== EKnowledgeBaseItemTypes.GUIDE ||
            props.hasPreview
          ) {
            return `brightness(0.7);`;
          }
          return '';
        }};
      }

      border-radius: 4px;
      width: 150px;
      height: 84px;
    }

    svg {
      position: relative;
      left: 45%;
      pointer-events: none;
      top: -70%;
    }
  }

  .description {
    &.completed {
      opacity: 0.5;
    }

    max-height: 45px;
    white-space: initial;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const PointsBlock = styled(Box)<WithType>`
  padding: 8px 0 18px 0;
  width: 100%;

  .label {
    &.completed {
      opacity: 0.5;
    }

    font-weight: bold;
    border-radius: 2px;
    width: 43px;
    height: 18px;
    text-align: center;
    margin-right: 5px;
    color: white;
    font-size: 10px;
    text-transform: capitalize;
    background-color: ${(props) => props.theme.knowledgeBase[props.type].color};
  }

  .points {
    font-weight: bold;
    line-height: 18px;
    color: ${(props) => props.theme.knowledgeBase[props.type].color};
    font-size: 12px;
  }

  .completed-box {
    color: ${(props) =>
      props.theme.knowledgeBase[EKnowledgeBaseItemTypes.GUIDE].color};
    margin-left: auto;
    font-size: 10px;

    .checkmark {
      margin-left: 5px;
      width: 12px;
    }
  }
`;
